import moment from "moment";

export const formatDateTime = (date: string): string | null => {
  let mDate = moment(date);

  if (mDate.isValid()) {
    return mDate.format("MM/DD/YYYY h:mm:ss a");
  }

  return null;
};

export const formatDate = (date: string): string | null => {
  let mDate = moment(date);

  if (mDate.isValid()) {
    return mDate.format("MM/DD/YYYY");
  }

  return null;
};

export const parseQueryString = (str: string): any => {
  const obj: any = {};

  str
    .replace("?", "")
    .split("&")
    .map((param) => param.split("="))
    .map((params) => ({ key: params[0], value: params[1] }))
    .forEach(({ key, value }) => (obj[key] = +value || value)); // try to cast to number

  // parse sort query param
  //   param has this format:
  //     <column_name> (eg. name, type, ...) for ASC sorted column
  //     <column_name>_desc (eg. name_desc, type_desc, ...) for DESC sorted column
  //   output is 2 fields:
  //     sortField = <column_name>
  //     sortOrder = -1 (DESC) | 1 (ASC)

  obj.sortField = "";
  obj.sortOrder = 0;

  if (obj.order) {
    const [sortField, sortOrder] = obj.order.split("_");
    obj.sortField = sortField;
    obj.sortOrder = sortOrder ? -1 : 1;
  }

  return obj;
};

export const toQueryString = (obj: any): string => {
  // if (obj.sortField) {
  //   obj.order = `${obj.sortField}${obj.sortOrder === 1 ? "" : "_desc"}`
  // }

  let queryString = Object.keys(obj)
    .filter((key) => key !== "sortField")
    .filter((key) => key !== "sortOrder")
    .filter((key) => obj[key] !== undefined)
    .filter((key) => obj[key] !== null)
    .filter((key) => obj[key] !== "")
    .map((key) => `${key}=${obj[key]}`)
    .join("&");

  return queryString ? `?${queryString}` : "";
};

export const orderIndexSort = (a: any, b: any) => a.order_index - b.order_index;

export const scrollToFirstInvalidElement = () => {
  const el: Element | null = document.querySelector(".p-invalid");

  if (el) {
    const { top } = el.getBoundingClientRect();
    window.scrollTo(0, window.scrollY + top);
  }
};
